import { UserType } from '../gql/graphql';

const staffUserTypes = new Set([UserType.Admin, UserType.Teacher]);

export function getPermissionFunctions(usersPermissions: Set<string>) {
  const hasPermission = (permission: string) =>
    usersPermissions.has(permission);

  const hasAtLeastOnePermission = (permissions: Array<string>) =>
    permissions.some((permission) => usersPermissions.has(permission));

  const hasAllPermissions = (permissions: Array<string>) =>
    permissions.every((permission) => usersPermissions.has(permission));

  return {
    hasPermission,
    hasAtLeastOnePermission,
    hasAllPermissions,
  };
}

export function isStaffUser(
  userType: UserType | undefined,
  tenant: number | undefined,
) {
  return (
    !!userType &&
    (staffUserTypes.has(userType) ||
      (UserType.Tyro === userType && tenant !== -32))
  );
}

export function isTyroTenantAndUser(
  userType: UserType | undefined,
  tenant: number | undefined,
) {
  return !!userType && UserType.Tyro === userType && tenant === -32;
}

export function isTyroUser(userType: UserType | undefined) {
  return !!userType && userType === UserType.Tyro;
}

export function isStudent(userType: UserType | undefined) {
  return !!userType && userType === UserType.Student;
}

export function isContact(userType: UserType | undefined) {
  return !!userType && userType === UserType.Contact;
}
